import React from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import makeDeprecatedJadeStyleTemplate from 'util/makeDeprecatedJadeStyleTemplate';

export interface PopupProps {
  closeable: boolean;
  title: string;
}

function Popup({closeable, title}: PopupProps): JSX.Element {
  return (
    <div className="modal-dialog popup" {...getTestProps({component: 'PopupTemplate', element: 'root'})}>
      <div className="modal-content">
        <div className="modal-header">
          {closeable && (
            <button type="button" data-dismiss="modal" aria-hidden="true" className="close">
              &times;
            </button>
          )}
          <h4
            className="modal-title"
            // oxlint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{__html: title}}
          />
        </div>
        <div className="modal-body" />
        <div className="modal-footer" />
      </div>
    </div>
  );
}

export default makeDeprecatedJadeStyleTemplate<PopupProps>(Popup);
